import type { GatsbyBrowser } from "gatsby"
import "@fontsource/playfair-display/400.css"
import "@fontsource/playfair-display/400-italic.css"
import "@fontsource/playfair-display/500.css"
import "@fontsource/playfair-display/600.css"
import "@fontsource/raleway/300.css"
import "@fontsource/raleway/400.css"
import "@fontsource/raleway/500.css"
import "@fontsource/raleway/600.css"
import "@fontsource/poppins/300.css"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "./src/styles/global.css"

// Album pages link to each other via Previous/Next; always land at the top
// instead of keeping the previous page's scroll position.
export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({ routerProps }) => {
  if (routerProps.location.pathname.startsWith("/album-")) {
    return [0, 0]
  }
  return true
}
